var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7641 9.46884L12.0002 13.4081L4.23625 9.46884L12.0002 5.52954L19.7641 9.46884ZM11.1058 15.2234C11.6688 15.5091 12.3316 15.5091 12.8946 15.2234L20.6585 11.2841C22.1326 10.5362 22.1326 8.4015 20.6585 7.65357L12.8946 3.71426C12.3316 3.42858 11.6688 3.42858 11.1058 3.71426L3.34183 7.65357C1.86773 8.4015 1.86772 10.5362 3.34182 11.2841L11.1058 15.2234ZM2.51454 16.4445L11.0289 21.2446C11.6329 21.5851 12.3674 21.5851 12.9715 21.2446L21.4858 16.4445C21.9686 16.1724 22.1426 15.5546 21.8743 15.0646C21.6061 14.5747 20.9973 14.3982 20.5145 14.6704L12.0002 19.4705L3.48583 14.6704C3.00304 14.3982 2.39424 14.5747 2.12602 15.0646C1.85781 15.5546 2.03176 16.1724 2.51454 16.4445Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.d78cd4d913a24f9bcb1dcc77d9f71415.svg";
export { ForwardRef as ReactComponent };